/* ============================================================
   ORION FOUNDER VIDEO — poster until the tap, then the real thing.
   The <video> lives in a <template> so no bytes move before the
   viewer asks. The tap is a user gesture, so playback with sound is
   allowed; if a browser still refuses, fall back to muted rather
   than to nothing.
   ============================================================ */
(() => {
  class OrionFounderVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === '1') return;
      this.dataset.ready = '1';
      const play = this.querySelector('[data-o-founder-play]');
      const tpl = this.querySelector('[data-o-founder-template]');
      if (!play || !tpl) return;
      play.addEventListener('click', () => {
        const frag = tpl.content.cloneNode(true);
        if (!frag.querySelector('video')) return;
        this.querySelectorAll('.o-founder__poster').forEach((p) => p.remove());
        this.appendChild(frag);
        this.classList.add('is-playing');
        const video = this.querySelector('video');
        video.muted = false;
        const attempt = video.play();
        if (attempt && attempt.catch) {
          attempt.catch(() => { video.muted = true; video.play().catch(() => {}); });
        }
      }, { once: true });
    }
  }
  if (!customElements.get('orion-founder-video')) {
    customElements.define('orion-founder-video', OrionFounderVideo);
  }
})();
